import React from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";

const PromoCodesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  formChildren,
  can_create,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("promo_codes.title"),
            createBtnTitle: can_create && t("promo_codes.add_promo_code"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "code",
                Header: t("promo_codes.code"),
                sort: true,
              },
              {
                accessor: "discount_percentage",
                Header: t("promo_codes.discount_percentage"),
                sort: true,
              },
              {
                accessor: "max_discount_amount",
                Header: t("promo_codes.max_discount"),
              },
              {
                accessor: "min_order_value",
                Header: t("promo_codes.min_order_value"),
              },
              {
                accessor: "expiry_date",
                Header: t("promo_codes.expiry_date"),
              },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t("promo_codes.search_by_code"),
            isChecked: false,
            total_count: count,
            isSort: true,
            setFilterObj,
            className: "main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList,
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details),
            structure: () => structure(t),
            validationSchema: validationSchema(t),
            deleteFun: deleteFun,
            title: id ? t("promo_codes.edit_promo_code") : t("promo_codes.add_promo_code"),
            submitTitle: id ? t("admin_users.btn_update") : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
            formChildren,
          }}
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default PromoCodesTemplate;
